import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RadioConditionKeyPipe } from './radio-condition-key.pipe';
import { RadioConditionsPipe } from './radio-conditions.pipe';
import { SymptomMethodsPipe } from './symptom-methods.pipe';
import { SymptomModePipe } from './symptom-mode.pipe';
import { SymptomValuePipe } from './symptom-value.pipe';
import { SymptomsPipe } from './symptoms.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    RadioConditionsPipe,
    RadioConditionKeyPipe,
    SymptomModePipe,
    SymptomsPipe,
    SymptomMethodsPipe,
    SymptomValuePipe
  ],
  exports: [
    RadioConditionsPipe,
    RadioConditionKeyPipe,
    SymptomModePipe,
    SymptomMethodsPipe,
    SymptomsPipe,
    SymptomValuePipe
  ]
})
export class SymptomsPipesModule {}
